export default __webpack_public_path__ + "static/media/project1.94f56128.png";